import { render } from "./NewJuice.vue?vue&type=template&id=28361c9c"
import script from "./NewJuice.vue?vue&type=script&lang=js"
export * from "./NewJuice.vue?vue&type=script&lang=js"

import "./NewJuice.vue?vue&type=style&index=0&id=28361c9c&lang=css"

import exportComponent from "/home/marc/E09/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__